import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import { postDetails } from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import { useAppDispatch } from "../../store/storeRequests";
import formatDate from "../../utils/helpers/formatDate";
import DynamicTable from "./DynamicTable";
import { hideToast, showToast } from "../../store/Toast/toast.slice";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);


    class ChartModel {
        labels: any;
        bindValue: string = '';
        datasets: dataSetModel[] = [];
    }

    class dataSetModel {
        label: string = '';
        bindValue: string = '';
        data: number[] = [];
        fill: boolean = false;
        backgroundColor: string = '';
        borderColor: string = '';
        borderWidth: number = 1;
    }


interface LineChartsProps {
    startDate: Date | null;
    endDate: Date | null;
    submit: boolean;

}

const LineChart: React.FunctionComponent<LineChartsProps> = ({ startDate, endDate, submit }) => {
    const dispatch = useAppDispatch();
    const [isDateSelected, setIsDateSelected] = useState(false)
    const [chart1, setChat1] = useState(new ChartModel());
    const [chart2, setChat2] = useState(new ChartModel());
    const [chart3, setChat3] = useState(new ChartModel());
     const [chart4, setChat4] = useState(new ChartModel());

     console.log("isDateSelected inside line chart", isDateSelected)


    useEffect(() => {
console.log('Fetch Called')
        fetchDashBoardData();
    }, [submit]);

    // console.log("ChartOB",chart1)
    // console.log("ChartOB",chart2)
    // console.log("ChartOB",chart3)
    // console.log("ChartOB",chart4)

    const fetchDashBoardData = async () => {
        try {
            dispatch(showLoader("Loading Data..."));

            const postObj = {
                "start_date": startDate === null ? '' : startDate,
                "end_date": endDate === null ? '' : endDate
            };
            const response:any= await postDetails(APIList.DASHBOARD_GET, postObj);
            // console.log(response, 'Dashboard Data');
            

            generateChartModel(response.data);



        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            dispatch(hideLoader());
        }
    };
    const getFourDatesBetween = (startDate: Date | null, endDate: Date | null) => {
        const start = new Date(startDate === null ? new Date() : startDate);
        const end = new Date(endDate === null ? new Date() : endDate);

        if(startDate !== null && endDate !== null){
            setIsDateSelected(true)
        }
    
        if (start > end) {
            throw new Error("Start date must be before end date.");
        }
    
        const timeDiff = end.getTime() - start.getTime();
        const totalDaysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    
        // function formatDate(date: Date): string {
        //     const year = date.getFullYear();
        //     const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
        //     const day = date.getDate().toString().padStart(2, '0');
        //     const hours = date.getHours().toString().padStart(2, '0');
        //     const minutes = date.getMinutes().toString().padStart(2, '0');
        //     const seconds = date.getSeconds().toString().padStart(2, '0');
          
        //     // Format as 'YYYY-MM-DD HH:MM:SS'
        //     return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
        //   }
          
        function formatDate(date: Date): string {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
            const day = date.getDate().toString().padStart(2, '0');
            
            let hours = date.getHours();
            const minutes = date.getMinutes().toString().padStart(2, '0');
            const seconds = date.getSeconds().toString().padStart(2, '0');
            
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12; 
            hours = hours ? hours : 12;
            
            return `${year}-${month}-${day} ${hours.toString().padStart(2, '0')}:${minutes} ${ampm}`;
        }
        
    
        let result: string[] = [];
    // console.log("TOTAL DAYS DIFF", totalDaysDiff )
        if (totalDaysDiff < 3) {
            for (let i = 3; i >= 0; i--) {
                const date = new Date(end);
                date.setDate(end.getDate() - i);
                result.push(formatDate(date));  // Format the date before adding it to the array
            }
        } else {
            const interval = timeDiff / 3;
            
    
            const date1 = start;
            const date2 = new Date(start.getTime() + interval);
            const date3 = new Date(start.getTime() + 2 * interval);
            const date4 = end; // End date
    
            result = [
                formatDate(date1),  // Format the dates
                formatDate(date2),
                formatDate(date3),
                formatDate(date4, )
            ];
        }
    
        return result;
    };
    
    // const getFourDatesBetween = (startDate: Date | null, endDate: Date | null) => {
    //     const start = new Date(startDate === null ? new Date() : startDate);
    //     const end = new Date(endDate === null ? new Date() : endDate);


    //     if (start > end) {
    //         throw new Error("Start date must be before end date.");
    //     }

 
    //     const timeDiff = end.getTime() - start.getTime();
    //     const totalDaysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

    //     let result = [];

    //     if (totalDaysDiff < 3) {
    //         for (let i = 3; i >= 0; i--) {
    //             const date = new Date(end);
    //             date.setDate(end.getDate() - i);
    //             result.push(date.toISOString().split('T')[0]);
    //         }
    //     } else {
    //         const interval = timeDiff / 3;

    //         const date1 = start; 
    //         const date2 = new Date(start.getTime() + interval);
    //         const date3 = new Date(start.getTime() + 2 * interval);
    //         const date4 = end; // End date

    //         result = [
    //             date1.toISOString().split('T')[0],
    //             // formatDate(date1, 'yyyy-mm-dd'),
               
    //             date2.toISOString().split('T')[0],
    //             date3.toISOString().split('T')[0],
    //             date4.toISOString().split('T')[0]
    //         ];
    //     }

    //     return result;
    // };
    const generateChartModel = (responseData: any[]): void => {
        //* Chart for Total Users
        let data1: ChartModel = {
            labels: getFourDatesBetween(startDate, endDate),
            bindValue: 'logindetails',
            datasets: [
                {
                    label: "Total",
                    bindValue: 'TotalUser',
                    data: [],
                    fill: false,
                    backgroundColor: "orange",
                    borderColor: "orange",
                    borderWidth: 1,

                },
                {
                    label: "iOS Users",
                    data: [],
                    bindValue: 'TotalIosUser',
                    fill: false,
                    backgroundColor: "red",
                    borderColor: "red",
                    borderWidth: 1,
                },
                {
                    label: "Android Users",
                    bindValue: 'TotalAndroidUser',
                    data: [],
                    fill: false,
                    backgroundColor: "green",
                    borderColor: "green",
                    borderWidth: 1,
                },
                {
                    label: "Login User",
                    bindValue: 'TotalLoginUser',
                    data: [],
                    fill: false,
                    backgroundColor: "green",
                    borderColor: "green",
                    borderWidth: 1,
                },
            ],
        };

        // *Chart for admin activity
        let data2: ChartModel = {
            labels: getFourDatesBetween(startDate, endDate),
            bindValue: 'adminactivity',
            datasets: [
                {
                    label: "Push Notification sent",
                    bindValue: 'Notification',
                    // data: [0, 0, 0, 0],
                    data: [],
                    fill: false,
                    backgroundColor: "red",
                    borderColor: "red",
                    borderWidth: 1,
                },
                {
                    label: "Post Added(Post + Images + Video)",
                    bindValue: 'gallary',
                    // data: [0, 0, 0, 0],
                    data: [],
                    fill: false,
                    backgroundColor: "orange",
                    borderColor: "orange",
                    borderWidth: 1,
                },
                {
                    label: "Quiz Added",
                    bindValue: 'quiz',
                    // data: [213, 0, 0, 0],
                    data: [],
                    fill: false,
                    backgroundColor: "blue",
                    borderColor: "blue",
                    borderWidth: 1,
                },
            ],
        };

// * Chart for user activity
        let data3: ChartModel = {
            labels: getFourDatesBetween(startDate, endDate),
            bindValue: 'useractivity',

            datasets: [
                {
                    label: "Images",
                    bindValue: 'userImage',
                    // data: [0, 0, 0, 0],
                    data: [],
                    fill: false,
                    backgroundColor: "red",
                    borderColor: "red",
                    borderWidth: 1,
                },
                {
                    label: "Videos",
                    bindValue: 'userVideo',
                    // data: [0, 0, 0, 0],
                    data: [],
                    fill: false,
                    backgroundColor: "green",
                    borderColor: "green",
                    borderWidth: 1,
                },
                {
                    label: "Post",
                    bindValue: 'userPost',
                    // data: [0, 0, 0, 0],
                    data: [],
                    fill: false,
                    backgroundColor: "blue",
                    borderColor: "blue",
                    borderWidth: 1,
                },
            ],
        };

        // *Chart for gamification activity
        let data4: ChartModel = {
            labels: getFourDatesBetween(startDate, endDate),
            bindValue: 'gamificationactivities',
            datasets: [
                {
                    label: "Total Quiz Attempted",
                    bindValue: 'getTotalAtemptedQuiz',
                    // data: [0.03],
                    data: [],
                    fill: false,
                    backgroundColor: "blue",
                    borderColor: "blue",
                    borderWidth: 1,
                },
            ],
        };
        responseData.forEach((chartRes, index) => {
            const loginChart = chartRes.logindetails;
            const adminactivityChart = chartRes.adminactivity;
            const useractivity = chartRes.useractivity;
            const gamificationactivities = chartRes.gamificationactivities;

          
    

            data1.datasets.map((sets) => {

                if (responseData.length === 1) {
                    sets.data = Array(4).fill(loginChart[sets.bindValue]);
                } else {
                    sets.data.push(loginChart[sets.bindValue]);
                }

            });
            data2.datasets.map((sets) => {

                if (responseData.length === 1) {
                    sets.data = Array(4).fill(adminactivityChart[sets.bindValue]);
                } else {
                    sets.data.push(adminactivityChart[sets.bindValue]);
                }

            });
            data3.datasets.map((sets) => {

                if (responseData.length === 1) {
                    sets.data = Array(4).fill(useractivity[sets.bindValue]);
                } else {
                    sets.data.push(useractivity[sets.bindValue]);
                }

            });
            data4.datasets.map((sets) => {

                if (responseData.length === 1) {
                    sets.data = Array(4).fill(gamificationactivities[sets.bindValue]);
                } else {
                    sets.data.push(gamificationactivities[sets.bindValue]);
                }

            });



        });        // Return the dynamically created ChartModel

        // console.log(data1,data2,data3,data4)
        
        // * Admin activity data is displayed under user activity data and vice versa
        setChat1(data1)
        setChat2(data3)
        setChat3(data2)
        setChat4(data4)
    };


    // const generateTableData = (chartData: any) => {
    //     // Extract headers from datasets (label) and add the first "Date" column
    //     const headers = ['Time', ...chartData.datasets.map((dataset:any) => dataset.label)];
      
    //     // Create table rows, with "Date" as the first column and dataset data as the other columns
    //     const data = chartData.labels.map((label:any, index:any) => {
    //       const row: any = { Date: label };
    //       chartData.datasets.forEach((dataset:any) => {
    //         row[dataset.label] = dataset.data[index];
    //       });
    //       return row;
    //     });
      
    //     return { headers, data };
    //   };


    const generateTableData = (chart: ChartModel) => {
        const headings = chart.datasets.map((dataset:any) => dataset.label)
        const headers = ["Time", ...headings];
        // console.log("Time:::",chart.labels)

      
        // const data = chart.datasets.map((dataset,index) => [
        //   ...dataset.data
        // ]);

        // const data = chart.labels.map((label:any, index:any) => {
        //           const row: any = { Date: label };
        //           chart.datasets.forEach((dataset:any) => {
        //             row[dataset.label] = dataset.data[index];
        //           });
        //           return row;
        //         });

        const data = chart.labels.map((label: any, index: any) => {
            const row: any[] = [label]; 
            chart.datasets.forEach((dataset: any) => {
                row.push(dataset.data[index]); 
            });
            return row; 
        });

                // console.log("table data",data)
        // const transposedData = transposeMatrix(data)
    
        return { headers, data };
      };



    const options = {
        responsive: true,
        scales: {
            
            y: {
                beginAtZero: true, 
                min: 0,
                max: 4000,         
                ticks: {
                    stepSize: 500, 
                    autoSkip: false,
                },
            },
        },
        
        plugins: {
            legend: {
                position: "bottom" as const,
            },
            
            title: {
                display: true,
                text: "Total Users Added Versus Logged In",
                color: "orange",
                font: {
                    size: 24,
                },
            },
        },
    };

    const options2 = {
        responsive: true,
        plugins: {
            legend: {
                position: "bottom" as const,
            },
            title: {
                display: true,
                text: "User activities",
                color: "orange",
                font: {
                    size: 24,
                },
            },
        },
    };

    const options3 = {
        responsive: true,
        plugins: {
            legend: {
                position: "bottom" as const,
            },
            title: {
                display: true,
                text: "Admin activities",
                color: "orange",
                font: {
                    size: 24,
                },
            },
        },
    };

    const options4 = {
        responsive: true,
        plugins: {
            legend: {
                position: "bottom" as const,
            },
            title: {
                display: true,
                text: "Gamification Activities",
                color: "orange",
                font: {
                    size: 24,
                },
            },
        },
    };

    // const headers = ['Time', 'Total Login', 'Android Login', 'iOS Login'];
    // const data = [
    //   { Time: '2024-09-17', 'Total Login': 12, 'Android Login': 0, 'iOS Login': 5 },
    //   { Time: '2024-09-18', 'Total Login': 12, 'Android Login': 0, 'iOS Login': 5 },
    //   { Time: '2024-09-19', 'Total Login': 12, 'Android Login': 0, 'iOS Login': 5 },
    //   { Time: '2024-09-20', 'Total Login': 12, 'Android Login': 0, 'iOS Login': 5 }
    // ];

    return (
        <div style={{ display: "flex", flexDirection: "column", margin: "10px" }}>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "5%",
                }}
            >
                <div style={{ flex: "1 1 45%", marginRight: "10px" }}>
                    <Line data={chart1} options={options} height={200}/>
                    {/* <DynamicTable headers={headers} data={data} /> */}
                 {  chart1.labels && <DynamicTable headers={generateTableData(chart1).headers} data={generateTableData(chart1).data} isDateSelected={isDateSelected} />}

                </div>
                <div style={{ flex: "1 1 45%", marginLeft: "10px" }}>
                    <Line data={chart2} options={options2} height={200}/>
                    {/* <DynamicTable headers={headers} data={data} /> */}
                    {chart2.labels && <DynamicTable headers={generateTableData(chart2).headers} data={generateTableData(chart2).data} isDateSelected={isDateSelected}/>}

                </div>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ flex: "1 1 45%", marginRight: "10px" }}>
                    <Line data={chart3} options={options3} height={200} />
                    {/* <DynamicTable headers={headers} data={data} /> */}
                  { chart3.labels &&  <DynamicTable headers={generateTableData(chart3).headers} data={generateTableData(chart3).data} isDateSelected={isDateSelected} />}

                </div>
                <div style={{ flex: "1 1 45%", marginLeft: "10px" }}>
                    <Line data={chart4} options={options4} height={200}/>
                    {/* <DynamicTable headers={headers} data={data} /> */}
                  { chart4.labels &&  <DynamicTable headers={generateTableData(chart4).headers} data={generateTableData(chart4).data} isDateSelected={isDateSelected}/>}

                </div>
            </div>
        </div>
    );
};

export default LineChart;
